var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.468 15.993c3.056 0 5.532-2.335 5.532-5.212 0-2.883-2.476-5.218-5.532-5.218l-1.94.01a.271.271 0 01-.276-.264c0-.146.124-.265.277-.265l7.454.001.003-2.212H5.527c-1.442 0-2.615 1.108-2.615 2.47 0 1.363 1.173 2.466 2.615 2.466l1.949.025c1.75 0 3.167 1.335 3.167 2.983 0 1.648-1.416 2.987-3.167 2.987H.003L0 16l7.468-.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.006 13.167h7.38c1.428 0 2.583-1.106 2.583-2.472 0-1.364-1.155-2.468-2.584-2.468l-1.924-.02c-1.726 0-3.126-1.34-3.126-2.993 0-1.65 1.4-2.989 3.126-2.989l7.366-.001L12.824 0H5.462C2.448 0 0 2.336 0 5.22c0 2.883 2.448 5.22 5.462 5.22l1.905.003c.145 0 .267.113.267.257 0 .14-.122.253-.267.253l-7.364.006.003 2.208"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSega);
export default __webpack_public_path__ + "static/media/SEGA.73737f843661a60d1ffcb97ba550c08a.svg";
export { ForwardRef as ReactComponent };